import React from "react";
import styled from "styled-components";
import mapboxgl from "mapbox-gl";

import IconClose from "../../assets/images/deine-buga__image--close.svg";

mapboxgl.accessToken = "pk.eyJ1IjoiMXRtLXNvbHV0aW9ucyIsImEiOiJjanc2M2s2YTkwN2F5NDFvNHpiYTd4Nmh4In0.mkalDMbbBjfDIwdP_CSfmg";

class MapCoordinatesSelector extends React.Component {
  mapRef = React.createRef();
  mapLocationRef = React.createRef();

  map = null;
  mapLocationMarker = null;

  state = {
    latitude: null,
    longitude: null
  };

  // This is probably not needed if the component has no reason to update (via props or state changes):
  // shouldComponentUpdate(){
  //   return false;
  // }

  onResetCoordinates = () => {
    this.setState({
      latitude: null,
      longitude: null
    });
    this.onSetCoordinates(null, null);
  };

  onSetCoordinates = (lat, lng) => {
    this.props.setCoordinates(lat, lng);
  };

  componentDidMount() {
    console.log("|-----#DEBUG | C:MapCoordinatesSelector|M:componentDidMount() | called -----:");

    const maxBounds = [
      [9.906946207678743, 48.35065572072739],
      [10.08871029717227, 48.437335930135305],
    ];
    
    this.map = new mapboxgl.Map({
      container: this.mapRef.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [9.998, 48.396],
      zoom: 12,
      maxBounds
    });

    this.map.on("click", event => {
      console.log("map click - event: ", event.lngLat);
      let { lat: latitude, lng: longitude } = event.lngLat;
      latitude = latitude.toFixed(5);
      longitude = longitude.toFixed(5);

      if (this.mapLocationMarker) {
        this.mapLocationMarker.remove();
      }

      this.mapLocationMarker = new mapboxgl.Marker().setLngLat(event.lngLat).addTo(this.map);

      this.setState({
        latitude,
        longitude
      });
    });

    this.map.on("load", () => {
    });
  }

  render() {
    const { latitude, longitude } = this.state;

    return (
      <MapCoordinatesSelectorWrapper>
        {/* <MapLocationMarker
          ref={this.mapLocationRef}
          isVisible={mapLocationMarker}
        /> */}
        <Map id="map" ref={this.mapRef} style={{ width: "100%", height: "100%" }} />
        <UsageInfo>Klicke auf die Karte um die Position festzulegen. </UsageInfo>
        {latitude && longitude && (
          <CoordinatesInfo>
            {`Koordinaten: ${latitude} LAT | ${longitude} LNG`} -{" "}
            <Button
              onClick={() => {
                this.onSetCoordinates(latitude, longitude);
              }}
            >
              Übernehmen
            </Button>
            <Button onClick={this.onResetCoordinates}>Löschen</Button>
          </CoordinatesInfo>
        )}
        <CloseButton
          onClick={() => {
            this.onResetCoordinates();
          }}
        />
      </MapCoordinatesSelectorWrapper>
    );
  }
}

const MapCoordinatesSelectorWrapper = styled.div.attrs({
  className: "absolute top-0 right-0 bottom-0 left-0 overflow-hidden"
})`
  min-height: 200px;
  min-width: 120px;
`;

const Map = styled.div.attrs({
  className: "absolute top-0 right-0 bottom-0 left-0"
})``;

const Button = styled.button.attrs({
  className: "pa2 ba link dib mid-gray bg-white ma1 br2"
})``;

const CloseButton = styled.button.attrs({
  className: "absolute top-0 right-1 mt1 mr1 border-box pt1 pr1 bn"
})`
  background-image: url(${IconClose});
  background-position: center;
  background-color: transparent;
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;
`;

const UsageInfo = styled.div.attrs({
  className: "pv1 ph3 bg-white-90 relative f7 gray"
})``;

const CoordinatesInfo = styled.div.attrs({
  className: "pb1 ph3 bg-white-90 relative f7 gray"
})``;

const MapLocationMarker = styled.div.attrs({
  className: "marker relative"
})`
  height: 12px;
  width: 12px;
  background-color: red;
  box-sizing: border-box;
  border: 2px dotted white;
  border-radius: 12px;
`;

export default MapCoordinatesSelector;
